export default {
  id: 'spv-light-node',
  instructionInfo: [
    '轻节点是一种在区块链网络中使用较少存储空间和计算资源的节点。常见的一个应用场景是移动支付，SPV轻节点适用于移动支付场景。由于移动设备资源有限，采用SPV轻节点可以在保证安全性的同时，减少存储和计算负担，SPV轻节点可以在保证验证交易的有效性，查询余额和交易记录等关键功能的情况下，无需下载完整的区块链数据，实现轻量化的目的，提高了用户体验和应用的可用性。'
  ]
}
